export default "__VITE_ASSET__NinfdJog__"